// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"2083a822","453":"52aa5bb0","621":"611d3b7e"}[chunkId] + ".chunk.js";
};